<button
  type="button"
  class="app-info-icon"
  [attr.aria-label]="label"
  [matTooltip]="resolvedTooltip"
  [matTooltipPosition]="tooltipPosition"
  [attr.data-testid]="testId"
>
  <mat-icon aria-hidden="true" fontSet="material-icons-outlined">{{
    icon
  }}</mat-icon>
</button>
